import React from 'react';
import { IconProps } from '../types/types';

const AXP: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#016FD0" d="M0 0h18v18H0z"/><path fillRule="evenodd" d="M5.611 3H4.75L2.573 9H4v5h5.915l.585-.693.6.693h4.133l-2.703-2.997L15.262 8H14V3h-3.356l-.219.67L10.17 3H5.611zM8 8L6.55 4h-1.1L4 8h.944l.268-.667h1.556L7.035 8H9V5.09L10 8h1l1-2.91V8h1V4h-1.63l-.87 2.667L9.481 4H8v4zM5 9v4h4.45l1.04-1.232L11.558 13h1.428l-1.805-2L13 9h-1.372l-1.102 1.252L9.428 9H5zm3 0v.895H6v.684h2v.842H6v.71h2V13l1.844-1.975L8 9zM6.462 6.333l-.475-1.37-.475 1.37h.95z" fill="#fff"/></svg>
);

export default AXP;